import { render, staticRenderFns } from "./AuthWidget.vue?vue&type=template&id=5e680a58&scoped=true"
import script from "./AuthWidget.vue?vue&type=script&lang=js"
export * from "./AuthWidget.vue?vue&type=script&lang=js"
import style0 from "./AuthWidget.vue?vue&type=style&index=0&id=5e680a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e680a58",
  null
  
)

export default component.exports